import * as React from 'react'
import type { SVGProps } from 'react'
export interface Infinity2IconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}
/**
 * infinity-2
 * Tabler Icons
 * @url https://icon-sets.iconify.design/tabler
 * @license MIT
 */
export const Infinity2Icon = (props: Infinity2IconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M13.94 9.39a10 10 0 0 1 .232-.218a4 4 0 1 1 0 5.656A10 10 0 0 1 12 12a10 10 0 0 0-2.172-2.828a4 4 0 1 0 0 5.656a10 10 0 0 0 .234-.219"
      />
    </svg>
  )
}
